import React from "react";
import { Link } from "react-router-dom";
import { Container } from "../ui/Container";
import { cn } from "../../utils/cn";

export interface FooterProps {
  className?: string;
}

const Footer: React.FC<FooterProps> = ({ className }) => {
  const currentYear = new Date().getFullYear();

  const legalLinks = [
    { label: "Privacy Policy", href: "/privacy" },
    { label: "Terms of Service", href: "/terms" },
    { label: "Compliance", href: "/compliance" },
    { label: "Refund Policy", href: "/refund" },
  ];

  return (
    <footer className={cn("bg-secondary-900 text-white", className)}>
      <Container size="xl" padding="md">
        <div className="py-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="flex items-center space-x-2">
              <img src="/logo.png" alt="Setgo Innovations" className="w-6 h-6" />
              <span className="font-semibold">Setgo Innovations</span>
            </div>
            <div className="flex flex-wrap justify-center gap-6">
              {legalLinks.map((link) => (
                <Link
                  key={link.label}
                  to={link.href}
                  className="text-secondary-300 hover:text-primary-400 transition-colors text-sm"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>
          <div className="mt-6 pt-6 border-t border-secondary-700 text-center text-sm text-secondary-400">
            &copy; {currentYear} Setgo Innovations Private Limited. All rights
            reserved.
          </div>
        </div>
      </Container>
    </footer>
  );
};

export { Footer };
